import React, { useContext, useRef } from 'react'

import HotelsTabContent from 'components/SearchV2/Components/Mobile/TabContents/HotelsTabContent'
import TextButton from 'components/Luxkit/Button/TextButton'
import { convertDatesToString, encodeSearchParams } from 'lib/search/searchUtils'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { replaceWithRegion } from 'actions/NavigationActions'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useLocation } from 'react-router'
import { useAppDispatch } from 'hooks/reduxHooks'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

interface Props {
  filters: App.OfferListFilters
}

function DestinationProductPageMobileSearchFrom({ filters }: Props) {
  const {
    searchItem,
    checkinDate,
    checkoutDate,
    occupancies,
    flexibleMonths,
    flexibleNights,
    userSelectedFlexibleMonths,
    isFlexibleDateSelected,
  } = useContext(GlobalSearchStateContext)

  const { search } = useLocation()
  const dispatch = useAppDispatch()

  const formRef = useRef<HTMLFormElement>(null)

  const onSearch = React.useCallback(() => {
    if (formRef.current?.reportValidity()) {
      const dates = convertDatesToString(ISO_DATE_FORMAT, checkinDate, checkoutDate)
      const queryParams = encodeSearchParams({
        urlSearch: search,
        searchItem,
        filters,
        dates,
        rooms: occupancies,
        isFlexibleWithDate: isFlexibleDateSelected,
        flexibleNights,
        flexibleMonths,
        userSelectedFlexibleMonths,
      }).toString()

      dispatch(replaceWithRegion('/search', queryParams))
    }
  }, [checkinDate, checkoutDate, search, searchItem, filters, occupancies, isFlexibleDateSelected, flexibleNights, flexibleMonths, userSelectedFlexibleMonths, dispatch])

  const onSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSearch()
  }

  return (
    <VerticalSpacer as="form" onSubmit={onSearchSubmit} gap={8} ref={formRef}>
      <HotelsTabContent isInPage onSearch={onSearch}/>
      <TextButton fit="full-width" kind="primary" type="submit" size="large">Search</TextButton>
    </VerticalSpacer>
  )
}

export default DestinationProductPageMobileSearchFrom
